<template>
  <div class="allocationDetail">
    <el-form ref="form" v-loading="loading" :model="form" class="baseInfoForm">
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电汇编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.telegraphicTransferNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇入公司：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.accountCompany }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              币种：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.currency }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              客户名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.importCompany }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇款日期：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.remittanceDate }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇款金额：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.remittanceAmount }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇入行：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.importBank }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇入账户：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.importAccount }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              状态：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.transferFromName }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              备注：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.summary }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              可用余额：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.unusedAmount }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              作废类型 ： <span> {{ form.rebuild }} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              申请作废理由 ： <span> {{ form. reason }} </span>
            </div>
          </div>
        </div>
      </div>
      <el-button type="primary" :loading="isErpLoading" @click="checkOut">
        点击校验ERP发货及发票核销情况
      </el-button>
      <span style="margin-left:10px; color:red">{{ checkOutStr }}</span>
      <div style="margin:10px">
        审批意见：
      </div>
      <el-input v-model="causeRevocation" type="textarea" maxlength="100" />
    </el-form>
  </div>
</template>

<script>
import { ToInvoiceView, checkShipped } from '@/API';
export default {
  name: 'AllocationDetail',
  data () {
    return {
      form: {},
      tableLoading: false,
      dataList: [],
      causeRevocation: '',
      isErpLoading: false,
      loading: false,
      checkOutStr: ''
    };
  },
  mounted () {
    this.initData();
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    initData () {
      this.loading = true;
      ToInvoiceView(this.id).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    checkOut () {
      this.isErpLoading = true;
      checkShipped(this.form.telegraphicTransferNum, this.form.rebuild).then((res) => {
        this.isErpLoading = false;
        let json = res.data;
        if (json.status === '200') {
          if (json.data) {
            this.checkOutStr = '可废弃';
            this.$emit('onStatus', true);
          } else {
            this.checkOutStr = '不可废弃';
            this.$emit('onStatus', false);
          }
        } else {
          this.checkOutStr = '';
          this.$emit('onStatus', false);
        }
      }).catch(() => {
        this.checkOutStr = '';
        this.isErpLoading = false;
        this.$emit('onStatus', false);
      });
    }
  }
};
</script>

<style>

</style>
